<div class="page-container">
  <!-- Filtros arriba -->
  <div class="filters-row">
    <mat-form-field appearance="fill">
      <mat-label>Desde</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" (dateChange)="applyDateFilter()" />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Hasta</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" (dateChange)="applyDateFilter()" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <!-- Dashboard abajo -->
  <div class="dashboard">
    <div id="dashboard"></div>
  </div>
</div>
